import React from 'react'
import './CertIndividualComponent.css'

export const CertIndividualComp = ({InterestBorderColor, InterestTitle, InterestDates, InterestLocation, JobCompany} ) => {
    return (
        <div className='CertListingIndex' >
            <div className='decorativeLine'></div>
            <p className='CertDate'> {InterestDates}</p>
            
            <div className='certTitleCircleWrapper'>
                <div className='certCircle' style={{ backgroundColor: InterestBorderColor }}></div>
                <h2 className='CertTitle'>{InterestTitle}</h2>
            </div>
            <p className='CompanyDes' style={{ color: InterestBorderColor }}>{JobCompany}</p>
            <p className='CertDescription'>{InterestLocation}</p>

        </div>
    )
}
